import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { DateLabels } from './const';
import { useCourse } from './useCourse';
import { useLocalize } from '../../hooks';
import { ProgressBar, Image, LabelDate } from '../../components';
import type { CoursesListType } from '../../api';

type CourseCardProps = {
  item: CoursesListType;
};

export const CourseCard: React.FC<CourseCardProps> = ({ item }) => {
  const { t } = useLocalize();
  const history = useHistory();
  const { course, loading } = useCourse(item?.courseId!);

  const handleCardClick = useCallback(
    (enrolmentId: string): void => {
      if (loading || !course?.modules?.length) return;

      history.push(`/courses/${enrolmentId}`);
    },
    [course, history, loading]
  );

  return (
    <div
      className="w-full flex flex-col h-full overflow-hidden"
      onClick={() => handleCardClick(item.id!)}
    >
      <div className="w-full relative">
        <Image
          imageUrl={item.imageUrl}
          title={item.title}
          className="w-full"
          imageClassName="rounded-xl overflow-hidden cursor-pointer object-cover aspect-[16/9]"
        />
      </div>

      <div className="flex flex-col py-md">
        <div className="flex justify-between items-center py-xs">
          <LabelDate
            date={item.deadline!}
            label={t(DateLabels.DEADLINE)}
            className="text-tiny text-textSecondary font-bold"
            formatDate="dd MMM yyyy"
          />
        </div>

        <div className="h-full pt-xs">
          <div className="text-big font-bold text-mainText leading-tight line-clamp-2 min-h-[4.5rem] pb-xs">
            {item.title}
          </div>
          <div className="text-tiny text-textSecondary flex-grow pt-xs line-clamp-2">
            {item.description}
          </div>

          <ProgressBar
            height="h-1.5"
            className="bg-lightGray mt-10"
            progressPercent={item.progressPercent!}
          />
        </div>
      </div>
    </div>
  );
};
